import AuthService from '../services/auth.service';

const authorization = JSON.parse(localStorage.getItem('authorization'));
const initialState = authorization
    ? {status: {loggedIn: true}, user: null}
    : {status: {loggedIn: false}, user: null};

export const auth = {
  namespaced: true,
  state: initialState,
  publicPages: ['/login', '/register'],

  actions: {
    async login({commit}, loginUser) {
      try {
        const loginResponse = await AuthService.login(loginUser);
        commit('loginSuccess');

        const currentUser = await AuthService.getCurrentUser();
        commit('currentUser', currentUser);

        return Promise.resolve(loginResponse);
      } catch (error) {
        commit('loginFailure');
        return Promise.reject(error);
      }
    },

    logout({commit}) {
      AuthService.logout();
      commit('logout');
    },

    register({commit}, signupRequest) {
      return AuthService.register(signupRequest).then(
          response => {
            commit('registerSuccess');
            return Promise.resolve(response.data);
          },
          error => {
            commit('registerFailure');
            return Promise.reject(error);
          }
      );
    },

    async loadCurrentUser({commit}) {
      try {
        const currentUser = await AuthService.getCurrentUser();
        commit('currentUser', currentUser);
        return currentUser;
      } catch (error) {
        commit('currentUser', null);
        return null;
      }
    }
  },

  mutations: {
    loginSuccess(state) {
      state.status.loggedIn = true;
    },

    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },

    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },

    registerSuccess(state) {
      state.status.loggedIn = false;
    },

    registerFailure(state) {
      state.status.loggedIn = false;
    },

    currentUser(state, currentUser) {
      state.user = currentUser;
    }
  }
};